/**
 * Calculates the percentage difference between two numbers.
 * It returns a float or positive/negative infinity.
 * @param a The first number.
 * @param b The second number.
 * @returns The percentage difference between a and b.
 */
export const calculateDeltaPercentage = (a: number, b: number): number => {
  if (a === 0 && b > 0) {
    return Number.POSITIVE_INFINITY
  }
  if (a === 0 && b < 0) {
    return Number.NEGATIVE_INFINITY
  }
  if (a > 0 && b === 0) {
    return -100
  }
  if (a === b) {
    return 0
  }
  return ((b - a) / a) * 100
}
